import type { QueryClient } from '@tanstack/react-query';
import { queryKeys } from './queryKey';

export function invalidateResourceQueries(
  qc: QueryClient,
  resourceType: 'estate' | 'project',
  resourceId: string
) {
  qc.invalidateQueries({ queryKey: queryKeys.documents(resourceId) });
  qc.invalidateQueries({ queryKey: queryKeys.folderFiles(resourceType, resourceId) });
  qc.invalidateQueries({ queryKey: queryKeys.archives(resourceType, resourceId) });
}
